import { FullScreenSpinner } from "~/v2/components/common";
import { useFundingHomeController } from "./FundingHome.controller";
import { FundingHomePresentation } from "./FundingHome.pres";

export const FundingHomeConnector = () => {
  const {
    accountID,
    relationships,
    isLoading,
    showWithdraw,
    onWithdrawClicked,
    onDepositClicked,
    onPortfolioTransferClicked,
  } = useFundingHomeController();

  if (isLoading) {
    return <FullScreenSpinner />;
  }

  return (
    <FundingHomePresentation
      accountID={accountID}
      relationships={relationships}
      showWithdraw={showWithdraw}
      onDepositClicked={onDepositClicked}
      onWithdrawClicked={onWithdrawClicked}
      onPortfolioTransferClicked={onPortfolioTransferClicked}
    />
  );
};
